// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cff3a706","239":"7dbc1625","455":"30f27f0d"}[chunkId] + ".chunk.js";
};